///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor = abcsetup.duplicate_vendor || {};
abcsetup.duplicate_vendor.common = abcsetup.duplicate_vendor.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor.common = {

    // Variables
    workflow_task: null,
    license_tasks: [
        'duplicate_brx_vendor_rep_reject',
        'duplicate_brx_vendor_risk_reject',
        'duplicate_brx_vendor',
        'duplicate_brx_rep_review',
        'duplicate_brx_vendor_final',
        'duplicate_brx_csra_review',
        'duplicate_brx_gsmd_review',
        'duplicate_grx_vendor_rep_reject',
        'duplicate_grx_vendor_risk_reject',
        'duplicate_grx_vendor',
        'duplicate_grx_rep_review',
        'duplicate_grx_vendor_final',
        'duplicate_grx_csra_review',
        'duplicate_grx_cm_approve',
        'duplicate_grx_gsmd_review',
        ],
    supplier_license_tasks: [
        'duplicate_brx_vendor_rep_reject',
        'duplicate_grx_vendor_rep_reject',
        'duplicate_brx_csra_review',
        'duplicate_grx_csra_review',
    ],
    rx_roles: [
        'brand_rep',
        'grx_rep',
        ],

    bindFormElems: function () {
        // Assign the local workflow_task var
        this.workflow_task = JSON.parse($('#WorkflowTask').val());

        abcsetup.duplicate_vendor.common._updatePaymentTermsTable();
        abcsetup.duplicate_vendor.common._toggleLicenses();

        // When the divisions checkbox is changed in the duplicate info tab, we need to enable those columns in the payment terms tab table
        $(document).on('change', '#app_models_duplicate_vendor_duplicate_supplier_divisions, #app_models_duplicate_vendor_payment_terms_payment_terms_exclude_hawaii_terms, #app_models_duplicate_vendor_payment_terms_payment_terms_hawaii_terms_same_as_mainland, #app_models_duplicate_vendor_payment_terms_payment_terms_exclude_puerto_rico_terms, #app_models_duplicate_vendor_payment_terms_payment_terms_puerto_rico_terms_same_as_mainland', function (event) {
            abcsetup.duplicate_vendor.common._updatePaymentTermsTable();
        });

        // Do you plan to supply controlled substances to Cencora
        $(document).on('change', '#app_models_duplicate_vendor_dea_dea_federal_controlled_substance', function() {
            abcsetup.duplicate_vendor.common._toggleLicenses();
        });

        $(document).on('change', '#app_models_duplicate_vendor_dea_dea_narcotics', function() {
            abcsetup.duplicate_vendor.common._toggleLicenses();
        });

        // Authorized Trading Partner table
        $(document).on('change keyup', '.authorized_trading_partner_table input', function () {
            var blankRow = false;

            $('.authorized_trading_partner_table').each(function () {
                if ($(this).find('input').filter(function () { return $(this).val() === ''; }).length == 2) {
                    blankRow = true;
                }
            })

            if (!blankRow) {
                var row = $('.authorized_trading_partner_table:last').clone();
                row.find('input').val('').attr('required', false).attr('requiredIf', '').removeClass('invalid');

                // Apply a uid to the 2 fields and make them dependant on eachother
                var id = abcsetup.randomString();
                row.find('input.authorized_trading_partner_ein').attr('id', 'authorized_trading_partner_ein_' + id).attr('requiredIf', 'authorized_trading_partner_affiliate_names_' + id + '!=');
                row.find('input.authorized_trading_partner_affiliate_names').attr('id', 'authorized_trading_partner_affiliate_names_' + id).attr('requiredIf', 'authorized_trading_partner_ein_' + id + '!=');
                row.find('input.authorized_trading_partner_ein_start_dates').attr('id', 'authorized_trading_partner_ein_start_dates_' + id).attr('requiredIf', 'authorized_trading_partner_ein_' + id + '!=');
                row.find('small').remove();
                $('.authorized_trading_partner_table:last').after(row);
            }
        });

        $('.authorized_trading_partner_table input').eq(0).trigger('change');

        // Making this field read-only via JS because using asText() in the field collection kills all the conditional license displaying JS around it
        if ($.inArray(this.workflow_task.task, this.supplier_license_tasks) !== -1) {
            $('input[name="licenses[]"]').prop("readonly", true);
            $('input[name="divisions[]"]').prop("readonly", true);
        }

        // Add license expiration alerts for each state
        if (abcsetup.userRole.class == 'rx_vendor' || abcsetup.userRole.class == 'vendor' || abcsetup.userRole.class == 'brand_rep' || abcsetup.userRole.class == 'grx_rep') {
            $(document).on('change', '#app_models_vendor_license_alabama_license_alabama_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_colorado_license_colorado_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_florida_license_florida_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_mississippi_license_mississippi_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_missouri_license_missouri_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_north_carolina_license_north_carolina_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_ohio_license_ohio_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_oregon_license_oregon_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });

            $(document).on('change', '#app_models_vendor_license_texas_license_texas_license_expiration_date', function () {
                if ($(this).val()) {
                    const given = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(given.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "Your license is close to expiration. AB may block your item's distribution within this state until an updated license is provided. Click OK to continue.");
                    }
                }
            });
        }

        // Toggle the licenses tabs when divisions are changed
        // $('#app_models_duplicate_vendor_duplicate_supplier_divisions').on('change', function() {
        //     abcsetup.duplicate_vendor.common._applyLicenses();
        // });

        // Add warning message when awaiting state license approval checkbox is checked
        var approvalChecks = [
                $('#app_models_vendor_license_home_license_home_license_awaiting_approval'),
                $('#app_models_vendor_license_alabama_license_alabama_license_awaiting_approval'),
                $('#app_models_vendor_license_colorado_license_colorado_license_awaiting_approval'),
                $('#app_models_vendor_license_florida_license_florida_license_awaiting_approval'),
                $('#app_models_vendor_license_mississippi_license_mississippi_license_awaiting_approval'),
                $('#app_models_vendor_license_missouri_license_missouri_license_awaiting_approval'),
                $('#app_models_vendor_license_north_carolina_license_north_carolina_license_awaiting_approval'),
                $('#app_models_vendor_license_ohio_license_ohio_license_awaiting_approval'),
                $('#app_models_vendor_license_oregon_license_oregon_license_awaiting_approval'),
                $('#app_models_vendor_license_texas_license_texas_license_awaiting_approval'),
            ];

        var mapApprovals = $.map(approvalChecks, function(el){return el.get()});

        $(mapApprovals).on('click', function(){
             if ($(this).prop('checked')) {
                    abcsetup.alerts.show('WARNING', 'WARNING: Cencora will NOT be able to purchase items for sale to customers in this state without this license. Please click Close to continue.');
             }
        });

        // Check pending license checkbox on CSRA team's view if state licenses are awaiting approval
        $('.awaiting_approval').each(function() {
            $(this).prop('required', false);
            if ($(this).prop('checked')) {
                $(this).closest('.form-div').find('.is-pending').prop("checked", true);
            }
        });

        // Add helpText to each state license - TODO: this should be done at the field level
        $(':input[name^="licenses"][value="alabama_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for all Divisions 10, 20, 30 and 40</small>');
        $(':input[name^="licenses"][value="colorado_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="florida_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="mississippi_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="missouri_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="north_carolina_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="ohio_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="oregon_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for all Divisions 10, 20, 30 and 40</small>');
        $(':input[name^="licenses"][value="home_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for all Divisions 10, 20, 30 and 40</small>');
        $(':input[name^="licenses"][value="texas_license"]').closest('.form-group').append('<small class="form-text text-muted text-info pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40.</small>');

        $("form.form-wizard .bs-vertical-wizard").on("DOMSubtreeModified", function() {
            if (abcsetup.duplicate_vendor.common.workflow_task.task == 'duplicate_brx_vendor' || abcsetup.duplicate_vendor.common.workflow_task.task == 'duplicate_grx_vendor' || abcsetup.duplicate_vendor.common.workflow_task.task == 'duplicate_brx_rep_review' || abcsetup.duplicate_vendor.common.workflow_task.task == 'duplicate_grx_rep_review') {
                if ($('.bs-vertical-wizard ul li a:contains(License)').parent().not('[style="display: none;"]').length == $('.bs-vertical-wizard ul li.complete a:contains(License)').parent().not('[style="display: none;"]').length) {
                    $('#csra-btn').prop("disabled", false);
                }
            }
        });

        if (abcsetup.duplicate_vendor.common.workflow_task.task == 'duplicate_brx_rep_review' || abcsetup.duplicate_vendor.common.workflow_task.task == 'duplicate_grx_rep_review') {
            if ($('.bs-vertical-wizard ul li a:contains(License)').length > 0) {
                $('#csra-btn').prop('disabled', false);
            }
        }

        $(document).ready(function() {
            $('#app_models_duplicate_vendor_dea_dea_federal_controlled_substance, #app_models_duplicate_vendor_dea_dea_narcotics').on('change', function() {
                if ($('#app_models_duplicate_vendor_dea_dea_federal_controlled_substance').val() == 1 || $('#app_models_duplicate_vendor_dea_dea_narcotics').val() == 1) {
                    $('#csra-btn').text('Submit to QRO');
                    $('#actionButton').val('submit_to_csra').text('Submit to QRO');
                } else {
                    $('#csra-btn').text('Submit to GSMD');
                    $('#actionButton').val('submit_to_gsmd').text('Submit to GSMD');
                }
            });

            $('#app_models_duplicate_vendor_dea_dea_federal_controlled_substance, #app_models_duplicate_vendor_dea_dea_narcotics').trigger('change');
        });
    },

    /**
     * Auto check and disabled the license checkboxes when divisions change
     */
    _applyLicenses: function() {
        $(':checkbox[name^="licenses"]').each(function() {
                $(this).prop('checked', false).attr('readonly', false);
            })

        const selectedDivisions = $('input[name="divisions[]"]:checked').map(function(){
            return $(this).val();
        }).get();

        if ($('#app_models_duplicate_vendor_dea_dea_federal_controlled_substance').val() == 1 || $('#app_models_duplicate_vendor_dea_dea_narcotics').val() == 1) {
            $(':checkbox[name^="licenses"]:first').trigger('change');
        }
    },

    /**
     * Toggle the licenses tabs
     */
    _toggleLicenses: function() {
        if ($('#app_models_duplicate_vendor_duplicate_supplier_duplicate_supplier_type').val() != 'consumer') {
            if ($('#app_models_duplicate_vendor_dea_dea_federal_controlled_substance').val() == 1 || $('#app_models_duplicate_vendor_dea_dea_narcotics').val() == 1) {
                $('a[href="#wiz-primary_dea"]').closest('li').show();
                $('a[href="#wiz-secondary_dea"]').closest('li').show();
            }

            if ($('#app_models_duplicate_vendor_dea_dea_federal_controlled_substance').val() != 1 && $('#app_models_duplicate_vendor_dea_dea_narcotics').val() != 1) {
                $('a[href="#wiz-primary_dea"]').closest('li').hide();
                $('a[href="#wiz-secondary_dea"]').closest('li').hide();
                // Remove any requirements for hidden input fields that may try to validate on the front end
                $('a[href="#wiz-primary_dea"]').find('input,textarea,select').prop('required', false);
                $('a[href="#wiz-secondary_dea"]').find('input,textarea,select').prop('required', false);
            }
        }
    },

    /**
     *
     */
    _updatePaymentTermsTable: function () {
        var selectedDivisions = $('input[name="divisions[]"]:checked').map(function(){
            return $(this).val();
        }).get();

        $('.div-10').prop('required', selectedDivisions.includes('10'));
        $('.div-20').prop('required', selectedDivisions.includes('20'));
        $('.div-30').prop('required', selectedDivisions.includes('30'));
        $('.div-40').prop('required', selectedDivisions.includes('40'));

        $('#wiz-payment_terms .set-name').not(':visible').prop('required', false);

        // if the payment terms fields aren't set, default them to Z215 for consumer or Z227 for grx / brx
        var paymentTermsFields =
            $(`#app_models_duplicate_vendor_payment_terms_payment_terms_division_10_eft_payment_terms,
            #app_models_duplicate_vendor_payment_terms_payment_terms_division_20_eft_payment_terms,
            #app_models_duplicate_vendor_payment_terms_payment_terms_division_30_eft_payment_terms,
            #app_models_duplicate_vendor_payment_terms_payment_terms_division_40_eft_payment_terms`).toArray();

        paymentTermsFields.forEach(function (field) {
            if ($(field).val() == '') {
                if ($('#app_models_duplicate_vendor_duplicate_supplier_duplicate_supplier_type').val() == 'consumer') {
                    $(field).val('Z215');
                } else {
                    $(field).val('Z227');
                }
            }
        });
    },

    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        console.log(errorField.parent().html());
        abcsetup.unblockUI();
    }
}